import { Mail, MapPin, Phone } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-sky-100 bg-sky-950 text-sky-100">
      <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <img
              src="/logo-full-white.png"
              alt="Directive Pathway — Education and Visa Advisory"
              className="h-12 w-auto object-contain"
            />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-sky-200/80">
              Honest, personalised education and migration guidance — from Melbourne,
              for the world.
            </p>
          </div>

          <div>
            <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-sky-300">
              Explore
            </p>
            <div className="mt-4 flex flex-col gap-2.5">
              {[
                { label: "Services", id: "services", testid: "footer-link-services" },
                { label: "About", id: "about", testid: "footer-link-about" },
                { label: "Team", id: "team", testid: "footer-link-team" },
                { label: "Contact", id: "contact", testid: "footer-link-contact" },
              ].map((l) => (
                <button
                  key={l.id}
                  data-testid={l.testid}
                  onClick={() => scrollToId(l.id)}
                  className="w-fit text-sm text-sky-200/80 transition-colors hover:text-white"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </div>

          <div>
            <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-sky-300">
              Contact
            </p>
            <div className="mt-4 space-y-3 text-sm text-sky-200/80">
              <p className="flex items-start gap-2.5">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-sky-400" />
                Level 6/607 Bourke Street, Melbourne VIC 3000
              </p>
              <a
                data-testid="footer-email-link"
                href="mailto:admin@directivepathway.com.au"
                className="flex items-center gap-2.5 transition-colors hover:text-white"
              >
                <Mail className="h-4 w-4 shrink-0 text-sky-400" />
                admin@directivepathway.com.au
              </a>
              <p className="flex items-start gap-2.5">
                <Phone className="mt-0.5 h-4 w-4 shrink-0 text-sky-400" />
                <span className="flex flex-wrap items-center gap-x-2 gap-y-1">
                  {[
                    { num: "0449 132 525", tel: "0449132525", testid: "footer-phone-link" },
                    { num: "0402 207 660", tel: "0402207660", testid: "footer-phone-link-2" },
                    { num: "0403 811 726", tel: "0403811726", testid: "footer-phone-link-3" },
                  ].map((p, i) => (
                    <span key={p.tel} className="flex items-center gap-2">
                      {i > 0 && <span className="text-sky-500/50">·</span>}
                      <a data-testid={p.testid} href={`tel:${p.tel}`} className="transition-colors hover:text-white">
                        {p.num}
                      </a>
                    </span>
                  ))}
                </span>
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 border-t border-sky-800/60 pt-6 text-center text-xs text-sky-300/70">
          © 2026 Directive Pathway Advisors. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
